import React from "react";
import './Footer.css';

const Footer =(props) =>{
    return(
        <footer class="text-center text-lg-start bg-white text-muted bcclr">
            {/* <!-- Section: Social media --> */}
            <section class="d-flex justify-content-center justify-content-lg-between p-3 border-bottom">
                {/* <!-- Left --> */}
                <div class="Container w-50 text-center" >
                    <div class="mb-3 d-none d-lg-block">
                        <span>Social networks:</span>
                    </div>
                    {/* <!-- Left --> */}
                
                    {/* <!-- Right --> */}
                    <div id="icons">
                        <a  href="https://www.facebook.com/mohit.saxena.35513/"  class="me-3 link-secondary">
                            <i class="fa-brands fa-facebook"></i>
                        </a>
                        <a href="https://stackoverflow.com/users/19368893/mohit" class="me-3 link-secondary">
                            <i class="fab fa-stack-overflow"></i>
                        </a>
                        <a href="https://stackoverflow.com/users/19368893/mohit" class="me-3 link-secondary">
                        <i class="fab fa-twitter"></i>
                        </a>
                        <a href="https://www.instagram.com/rdx_maddy/" class="me-4 link-secondary">
                        <i class="fab fa-instagram"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/rdx-maddy-731934122/" class="me-3 link-secondary">
                        <i class="fab fa-linkedin"></i>
                        </a>
                        <a href="https://github.com/Mohit6795" class="me-3 link-secondary">
                        <i class="fab fa-github"></i>
                        </a>
                    </div>
                </div>

                <div class="Container w-50 text-center" >
                    <div class="mb-1 d-none d-lg-block">
                        <span>Download Mobile App</span>
                    </div>
                    <div id="icons" >
                        
                        <a href="https://play.google.com/store/apps/details?id=com.bikewale.app&referrer=utm_source%3DDesktopsite%26utm_medium%3DDrawer%26utm_campaign%3DBikeWale%2520Desktopsite%2520Drawer" class=" link-secondary">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/Screenshot%202022-08-17%20183654.png" alt="Playstore" class="socialimg1"/>
                        </a>
                        <a href="https://apps.apple.com/us/app/bikewale-buy-new-bike-scooty/id1492806145?ls=1" class="link-secondary">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/appllogo.png" alt="App store" class="socialimg1"/>
                        </a>
                    </div>
                </div>
            </section>
            <div class="text-center text-white border-bottom">
                {/* <!-- Grid container --> */}
                <div class="container p-1">
                {/* <!-- Section: Images --> */}
                    <section class="">
                        <div class="row justify-content-center ">
                        <div class="col-lg-2 col-md-12  ">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/bikewale1.png" class="w-100 df mt-1" alt="Bikewale"/>
                        </div>
                        <div class="col-lg-2 col-md-12  ">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/carexpert2.png" class="w-100 df" alt="carexpert"/>
                        </div>
                        <div class="col-lg-2 col-md-12  ">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/cartred3.png" class="w-100 df mt-1" alt="cartred"/>
                        </div>
                        <div class="col-lg-2 col-md-12  ">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/ouylok4.png" class="w-100 df" alt="ouylok"/>
                        </div>
                        <div class="col-lg-2 col-md-12  ">
                            <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/asure5.png" class="w-100 df" alt="Asure"/>
                        </div>

                        </div>
                    </section>
                </div>
            </div>
            <section class="">
                <div class="container text-center text-md-start mt-5">
                    <div class="row mt-3">
                    <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">
                        <i class="fas fa-gem me-3 text-secondary"></i>Bikewale
                        </h6>
                        <p>
                            BikeWale's mission is to bring delight in two-wheeler buying, we offer a bouquet of reliable tools and services to help motorcycle and scooter consumers decide on buying the right two-wheeler, at the right price and from the right partner.
                        </p>
                    </div>
                    <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">
                        Products
                        </h6>
                        <p>
                        <a href="#!" class="text-reset">Scooter</a>
                        </p>
                        <p>
                        <a href="#!" class="text-reset">Sport Bikes </a>
                        </p>
                        <p>
                        <a href="#!" class="text-reset">Budget Bikes</a>
                        </p>
                        <p>
                        <a href="#!" class="text-reset">Cruiser Bikes</a>
                        </p>
                    </div>
                    <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">
                        Useful links
                        </h6>
                        <p>
                        <a href="#!" class="text-reset">Pricing</a>
                        </p>
                        <p>
                        <a href="#!" class="text-reset">Settings</a>
                        </p>
                        <p>
                        <a href="#!" class="text-reset">Orders</a>
                        </p>
                        <p>
                        <a href="#!" class="text-reset">Help</a>
                        </p>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
                        <p><i class="fas fa-home me-3 text-secondary"></i> New York, NY 10012, US</p>
                        <p>
                        <i class="fas fa-envelope me-3 text-secondary"></i>
                        mohit.10saxena@gmail.com
                        </p>
                        <p><i class="fas fa-phone me-3 text-secondary"></i> + 01 234 567 88</p>
                        <p><i class="fas fa-print me-3 text-secondary"></i> + 01 234 567 89</p>
                    </div>
                    </div>
                </div>
            </section>
            {/* <!-- Copyright --> */}
            <div class="text-center p-4 btmclr">
            © 2022 Copyright:
            <a class="text-reset fw-bold" href="https://bikewale.com/">BIKEWALE.com &hearts;</a>
            </div>
        </footer>
    
    )
}
export default Footer;